import React from 'react';
import { ExternalLink } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const StorePage = () => {
  const gicleeSizes = [
    { size: '10" x 10"', price: '$250' },
    { size: '12" x 12"', price: '$300' },
    { size: '14" x 14"', price: '$350' },
    { size: '16" x 16"', price: '$400' },
    { size: '18" x 18"', price: '$450' },
    { size: '20" x 20"', price: '$500' }
  ];

  const prints = [
    // Modern collection — tiered giclée prints (edition of 10)
    {
      title: "Blue Street in Afternoon Light",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/38L7PNGHRA982",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_creative-icons/artifacts/bp89msuo_IMG_9%20high%20res.webp"
    },
    {
      title: "The Secret Before Spring",
      size: '18" x 18"',
      price: "$1,000",
      description: "Original acrylic on linen canvas",
      paypalLink: "https://www.paypal.com/ncp/payment/MB45LRHAG9T7N",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_creative-icons/artifacts/wesru92m_The%20Secret%20Before%20Spring.jpg"
    },
    {
      title: "The Secret Before Spring",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/WQCDAM9R76ZC4",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_creative-icons/artifacts/wesru92m_The%20Secret%20Before%20Spring.jpg"
    },
    {
      title: "Margo in Conversation",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/Q3GZXH6FNF2MN",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_creative-icons/artifacts/boj14zfd_Margo%20in%20Conversation.jpg"
    },
    {
      title: "Where Ivy Climbs and Love Resides",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/F75TQPDPDT4CW",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_creative-icons/artifacts/rbxqhiuv_IMG_3555.webp"
    },
    {
      title: "Brother and Sister on a Blossomed Path",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/5BHFE5DKJN9UW",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_creative-icons/artifacts/xmfpxzgr_IMG_3440%202.jpg"
    },
    {
      title: "Modern Apollo Against a Village Coastline",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/GNX2RPSE4A7R4",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_creative-icons/artifacts/kg0ehtmz_1.webp"
    },
    {
      title: "Modern Venus Rising",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/UFZJAJ8652NT2",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_creative-icons/artifacts/z26zzmvx_Modern%20Venus%20Rising.webp"
    },
    {
      title: "Venus in Repose",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/J4P8GNF5SV7HG",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_creative-icons/artifacts/6klb0k1d_IMG_3368.webp"
    },
    {
      title: "The Archivist",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/BF8YYWDNDK9E8",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_creative-icons/artifacts/xhm1t719_IMG_The%20Archivist.webp"
    },
    // Sensuality — tiered giclée prints
    {
      title: "The Lover's Kiss",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/T5H88F66F4WG2",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/b27d4c4a-76cb-43e0-9aea-dbdefa65b94c/The+Lovers+Kiss-highRes-20241110-fotor-202411271446.jpg"
    },
    {
      title: "The Bath",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/E95RD2PD3HSJL",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/f61130ce-225f-4a3a-82ef-bb8cd8995410/The+Bath.jpg"
    },
    {
      title: "God needs the Devil - Image 1",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/28M3WFTPXS9AG",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/4e6b3d9f-a9b3-44db-ac1b-903eaf220555/God+needs+the+Devil+Image+1.jpg"
    },
    {
      title: "God needs the Devil - Image 2",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/37GULMC4GWB22",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/d7a271dc-2995-4188-a912-3e565b28063b/God+needs+the+Devil+Image+2+High+res.jpg"
    },
    {
      title: "God needs the Devil - Image 3",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/H4AP57UM4YNJU",
      image: "https://customer-assets.emergentagent.com/job_creative-icons/artifacts/asflih0e_Witherell_God%20needs%20the%20Devil%20Image%203_Acrylic_30x30_2026-fotor-2026042419947.jpg"
    },
    {
      title: "Tell me how... Image 1",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/5HHC53WTX73WG",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/452ef97d-2cd2-4ed2-b79d-5e3c01bc5e9a/Tell+me+how...to+Stand.jpg"
    },
    {
      title: "Tell me how... Image 2",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/Y2L752K6Z6CFA",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/299eb132-ea9f-4dc8-b38c-d35544570103/_Leigh+Witherell-Tell+me+how+-Image+2.jpg"
    },
    {
      title: "Tell me how... Image 3",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/63XGJTV7Y6U6N",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/767fae61-c985-4fcc-8879-bb7d83604181/Image+3.jpg"
    },
    {
      title: "Tell me how... Image 5",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/R6ASGX92L28E2",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/be3d6369-e1ad-42f3-8a8d-73b55873c89e/Image+5+-+highres-min.jpg"
    },
    {
      title: "Tell me how... Image 6",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/YNGZ3RVFRG6LJ",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/cc567bc3-92a1-4020-8067-bcc5cbeda727/Tell+me+how...Image+6.jpg"
    },
    {
      title: "Tell me how... Image 7",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/28M3WFTPXS9AG",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/d7bb6c38-7759-4323-b3b0-9b522e104843/Tell+me+how...Image+7.JPG"
    },
    {
      title: "Tell me how... Image 8",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/YTC4U84L5Z836",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/750968bd-9646-467f-8ab9-12c8091ac12e/Tell+me+how...Image+8.jpg"
    },
    {
      title: "Tell me how... Image 10",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/T9QGN7TJ7GWZ2",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/602fd8c9-7076-4857-bb35-b5878c374813/Tell+me+how...+Image+10-High+res.jpg"
    },
    {
      title: "Villains aren't born...",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/HA4HN3LP7RE66",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/61b48aa5-228e-479a-8b43-6e93f3f39f7e/Villains.jpg"
    },
    // Melancholy / portraits — tiered giclée prints
    {
      title: "Alli",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/FJYS575GJWUJY",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/ab85e010-a7a6-4e41-91ea-4d8e2adf2082/Alli.jpg"
    },
    {
      title: "Hidden Wounds",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/8CVRLAQAWNS82",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/5330517e-bdc5-4cf1-96b3-0a78b53b3e05/Hidden+Wounds-LowRes-20241110.jpg"
    },
    {
      title: "The Artist: Self-Reflection",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/Q3BZBACEGDRRQ",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/1721840280712-SK043WHC61I710RACD1B/The+Artist+Self+Reflection+30x30.JPG"
    },
    {
      title: "Jim",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/SGC4A876WJ87C",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/aa563c81-3dca-4969-a8a2-f8c3c33b80f6/Jim.JPG"
    },
    {
      title: "Eric",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/GY8FWT5T34LJ6",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/2dbfd5d0-d8e6-4617-bd81-d43c140afe66/IMG_6429.JPG"
    },
    {
      title: "A Moment",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/FP52L29ARKB5W",
      image: "https://customer-assets.emergentagent.com/job_creative-icons/artifacts/2wio991g_A%20Moment.jpg"
    },
    {
      title: "Freedom",
      sizeOptions: true,
      description: "Giclée print — limited edition of 10",
      paypalLink: "https://www.paypal.com/ncp/payment/6VCS5JE2SQXW2",
      image: "https://customer-assets.emergentagent.com/job_creative-icons/artifacts/u0swirqo_Freedom.jpg"
    }
  ];

  return (
    <div className="min-h-screen bg-off-black">
      <Navigation />

      {/* Content */}
      <div className="pt-24 sm:pt-28 md:pt-32 pb-16 sm:pb-24 md:pb-32 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Page Title */}
          <div className="mb-12 sm:mb-16 md:mb-24">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-soft-ivory tracking-tight mb-3 sm:mb-4">
              Limited Edition Prints
            </h1>
            <div className="w-16 sm:w-20 h-1 bg-flesh-tone mb-4 sm:mb-6"></div>
            <p className="text-sm sm:text-base md:text-lg text-muted-warm-grey max-w-3xl">
              Original limited edition prints of contemporary figurative artwork. Each print is carefully produced to museum quality standards.
            </p>
          </div>

          {/* Prints Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 md:gap-12">
            {prints.map((print, index) => (
              <div key={`print-${index}-${print.title.substring(0, 10)}`} className="group flex flex-col">
                <div className="mb-4 sm:mb-6 overflow-hidden border border-zinc-800 h-64 sm:h-80 md:h-96 flex items-center justify-center bg-deep-charcoal">
                  <img
                    src={print.image}
                    alt={print.title}
                    className="max-w-full max-h-full object-contain transform group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="space-y-3 sm:space-y-4 flex-grow flex flex-col">
                  <h3 className="text-lg sm:text-xl font-serif text-soft-ivory tracking-tight">
                    {print.title}
                  </h3>

                  {print.sizeOptions ? (
                    <>
                      <p className="text-xs sm:text-sm text-muted-warm-grey">
                        {print.description}
                      </p>
                      <div className="border-t border-b border-zinc-800 py-3 space-y-1.5">
                        {gicleeSizes.map((opt) => (
                          <div
                            key={opt.size}
                            className="flex items-baseline justify-between text-xs sm:text-sm text-soft-ivory tracking-wide"
                          >
                            <span className="tabular-nums">{opt.size}</span>
                            <span className="font-serif text-muted-warm-grey">·</span>
                            <span className="tabular-nums text-soft-ivory">{opt.price}</span>
                          </div>
                        ))}
                      </div>
                      <p className="text-xs text-muted-warm-grey italic">
                        Select your size at checkout
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="text-xs sm:text-sm text-muted-warm-grey">
                        {print.size} • {print.description || "Original limited edition print"}
                      </p>
                      <p className="text-xl sm:text-2xl font-serif text-soft-ivory">
                        {print.price}
                      </p>
                    </>
                  )}

                  <div className="border border-zinc-800 bg-deep-charcoal p-3 sm:p-4 hover:border-flesh-tone transition-colors duration-400 mt-auto">
                    <a
                      href={print.paypalLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2 text-soft-ivory hover:text-flesh-tone text-xs sm:text-sm tracking-widest uppercase transition-colors duration-400 font-medium"
                    >
                      Purchase
                      <ExternalLink size={14} className="sm:w-4 sm:h-4" />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default StorePage;
